module.exports = __webpack_public_path__ + "static/media/xcelIco.79adce06.png";